import { getThreadMembers } from '../selectors/members';
import { postThread } from './threads';
import { updateMessage, postMessage } from './messages';

export function resendMessage(thread: $TSFixMe, message: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe) => {
        dispatch(updateMessage(thread.id, message.id, { isFailed: false }));
        if (thread.isStub) {
            const members = getThreadMembers(getState(), { id: thread.id });
            dispatch(postThread(thread, message, members));
        } else {
            dispatch(postMessage(thread.id, message.id, message.text));
        }
    };
}
